import { SubmissionError } from 'redux-form';
import { MY_CARRIER_REQUIRED_FIELDS, REQUIRED_FIELDS } from './constants';
import { MY_CARRIER_ID } from '../../../request-modal/constants';

export const transformToValidationErrors = errors => {
	return Object.entries(errors).reduce((prev, [key, error]) => {
		if (!prev[key]) {
			prev[key] = {};
		}

		prev[key] = error;

		return prev;
	}, {});
};

export const validate = values => {
	let fields = REQUIRED_FIELDS;

	if (values.tender_type_id === MY_CARRIER_ID) {
		fields = [...MY_CARRIER_REQUIRED_FIELDS, ...fields.slice(1)];
	}
	fields.forEach(key => {
		if (!values?.[key]) {
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};
